//
//
//
//
//

import lazy_load_mixin from './lazy_load_mixin'
export default {
    mixins: [
        lazy_load_mixin('.fc-icon')
    ],
    props: {
        type: {
            type: String
        }
    },
    computed: {
        src () {
            return require(`../../assets/icon/${this.type}.png`)
        },
        style () {
            const matched = this.type.match(/^\d+/g)
            if (matched.length) {
                const size = (matched[0] / 2) + 'px'
                return {
                    width: size,
                    height: size
                }
            }
            return {}
        }
    }
}
